import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHotelwoning = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#0061CD"
      d="M9.83 10a5 5 0 0 1 2.77-4.41A5.4 5.4 0 0 0 10.13 5a5.12 5.12 0 0 0-5.23 5 5.12 5.12 0 0 0 5.23 5 5.4 5.4 0 0 0 2.47-.59A5 5 0 0 1 9.83 10"
    />
    <path
      fill="#85BDED"
      fillRule="evenodd"
      d="m8 14 12-8 12 8v20H8z"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      d="M28 19v6h-1.68a3 3 0 0 0-5.64 0h-1.36a3 3 0 0 0-5.64 0H12v-6a1 1 0 0 1 2 0v1h12v-1a1 1 0 0 1 2 0m-1 7H13a2 2 0 0 0-2 2v5h2v-2h14v2h2v-5a2 2 0 0 0-2-2"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m25.525 11.33 8.6 5.97-.57.82-8.6-5.97z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHotelwoning);

export default ForwardRef;
